var React = require('react');

function Share (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m96 0a96 96 0 1 0 96 96 96.108 96.108 0 0 0 -96-96zm-24 96c0 .524-.023 1.042-.056 1.557l35.992 25.709a23.994 23.994 0 1 1 -10.381 12.247l-32.179-22.984a24 24 0 1 1 0-33.058l32.179-22.984a24.045 24.045 0 1 1 10.381 12.247l-35.992 25.709c.033.515.056 1.033.056 1.557z"}));
}

Share.defaultProps = {"viewBox":"0 0 192 192"};

module.exports = Share;

Share.default = Share;
